var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Rnd } from "react-rnd";
import { valueFromString } from "../../utils/functions";
import { onDragStop, onResizeStop } from "../../utils/rndHelper";
export const RndWrapper = (_a) => {
    var { isLocked, isSelected, showAnimations, screenWidth, screenHeight, layoutItem, updateLayoutItem, scale, setSelectedLayoutItem, widgetResize, children } = _a, rest = __rest(_a, ["isLocked", "isSelected", "showAnimations", "screenWidth", "screenHeight", "layoutItem", "updateLayoutItem", "scale", "setSelectedLayoutItem", "widgetResize", "children"]);
    const rndSize = {
        width: valueFromString(layoutItem.width, screenWidth, 0.25 * screenWidth),
        height: valueFromString(layoutItem.height, screenHeight, 0.25 * screenHeight),
    };
    const rndPosition = {
        x: valueFromString(layoutItem.x, screenWidth),
        y: valueFromString(layoutItem.y, screenHeight),
    };
    return (React.createElement(Rnd, Object.assign({ disableDragging: !isSelected || isLocked || showAnimations, size: rndSize, position: rndPosition, style: {
            outline: isSelected && !showAnimations
                ? `${2 / scale}px solid  var(--chakra-colors-orange-400)`
                : "none",
            zIndex: layoutItem.z,
        }, cancel: ".rnd-cancel", resizeGrid: [screenWidth / 100, screenHeight / 100], dragGrid: [screenWidth / 100, screenHeight / 100], onDragStop: (e, d) => onDragStop({
            d,
            layoutItem,
            updateLayoutItem,
            screenWidth,
            screenHeight,
        }), scale: scale, onResizeStop: (e, direction, ref, delta, position) => onResizeStop({
            ref,
            position,
            layoutItem,
            updateLayoutItem,
            screenWidth,
            screenHeight,
            direction,
        }), enableResizing: widgetResize, onClick: () => {
            if (showAnimations)
                return;
            setSelectedLayoutItem(layoutItem.id);
        }, bounds: "#studio-preview" }, rest), children));
};
